import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 472463C9-3A6A-47E9-9ED9-9DEF17C3ACDA
 * name file-image-remove-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-image-remove-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileImageRemoveOutlineIcon = createSvgIcon(<><path d="M7 19L12 14L13.88 15.88C13.33 16.79 13 17.86 13 19H7M10 10.5C10 9.67 9.33 9 8.5 9S7 9.67 7 10.5 7.67 12 8.5 12 10 11.33 10 10.5M13.09 20H6V4H13V9H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V8L14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.46 21.39 13.21 20.72 13.09 20M21.12 15.46L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88L21.12 15.46Z" /></>, 'FileImageRemoveOutlineIcon');
export default FileImageRemoveOutlineIcon